'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = exports.ToolsArea = exports.WorkArea = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ToolsArea = require('./ToolsArea');

var _ToolsArea2 = _interopRequireDefault(_ToolsArea);

var _WorkArea = require('./WorkArea');

var _WorkArea2 = _interopRequireDefault(_WorkArea);

var _Settings = require('./Settings');

var _Settings2 = _interopRequireDefault(_Settings);

var _reactRedux = require('react-redux');

var _templates = require('redux/modules/templates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateEditor = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TemplateEditor, _Component);

  function TemplateEditor() {
    (0, _classCallCheck3.default)(this, TemplateEditor);
    return (0, _possibleConstructorReturn3.default)(this, (TemplateEditor.__proto__ || (0, _getPrototypeOf2.default)(TemplateEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(TemplateEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectComponent = this.props.selectComponent;

      selectComponent('root');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          root = _props.root,
          selectedComponent = _props.selectedComponent;

      var styles = require('./TemplateEditor.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.root) },
        _react2.default.createElement(
          'div',
          { className: 'inner-scroll-layout' },
          _react2.default.createElement(
            'div',
            { className: 'inner-scroll-wrapper' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('inner-scroll-fixed', styles.header) },
              _react2.default.createElement(_Settings2.default, { className: styles.settings })
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('inner-scroll-scrollable', styles.content) },
              _react2.default.createElement(_WorkArea2.default, { className: styles.workArea, root: root }),
              _react2.default.createElement(_ToolsArea2.default, { className: styles.toolsArea, component: selectedComponent })
            )
          )
        )
      );
    }
  }]);
  return TemplateEditor;
}(_react.Component), _class.propTypes = {
  root: _react.PropTypes.object,
  selectedComponent: _react.PropTypes.object,
  settings: _react.PropTypes.object,
  className: _react.PropTypes.string
}, _temp);


var mdtp = {
  selectComponent: _templates.selectComponent
};

exports.default = (0, _reactRedux.connect)(null, mdtp)(TemplateEditor);
exports.WorkArea = _WorkArea2.default;
exports.ToolsArea = _ToolsArea2.default;
exports.Settings = _Settings2.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateEditor/TemplateEditor.jsx
// module id = 1646
// module chunks = 0